import { useState } from 'react'
import { AlertTriangle } from 'lucide-react'
import { RunsForDeliverySheet } from './RunsForDeliverySheet'
import type { DeliveryForRuns } from '@/lib/openRunsForDelivery'
import { useProductionFlow } from '@/lib/useProductionFlow'
import { useFlowManifest } from '@/hooks/useCommodityTemplates'

/** "Put on a run" for the delivery page and the Yard card. The CALLER decides
 *  the delivery has no linked run (a good read, never a failed or pending one),
 *  exactly as the board chip does; this adds the berry rule and opens the
 *  same sheet. */
export function PutOnRunButton({ delivery }: {
  delivery: DeliveryForRuns & { delivery_id: string; bins_remaining?: number }
}) {
  const [open, setOpen] = useState(false)
  const manifest = useFlowManifest(useProductionFlow())
  if (manifest.usesForceCooling) return null
  return (
    <>
      <button type="button" onClick={() => setOpen(true)}
        className="inline-flex items-center justify-center gap-1 min-h-[44px] rounded-lg px-3 text-caption font-semibold bg-warning-soft text-warning border border-warning-edge">
        <AlertTriangle size={12} /> Put on a run
      </button>
      {open && <RunsForDeliverySheet delivery={delivery} onClose={() => setOpen(false)} />}
    </>
  )
}
